import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from './components/App/App';
import WelcomeToBookApp from './components/WelcomeToBookApp/WelcomeToBookApp';
import AdminApp from './components/Admin/AdminApp/AdminApp';
import AdminHomePage from './components/Admin/AdminHomePage/AdminHomePage';
import UserApp from './components/User/UserApp/UserApp';
import UserHomePage from './components/User/UserHomePage/UserHomePage';

import OrderHistory from './components/OrderHistory/OrderHistory';
import OrderDetail from './components/OrderDetail/OrderDetail';
import NewOrder from './components/NewOrder/NewOrder';
import PendingReviews from './components/PendingReviews/PendingReviews';
import PendingReviewDetail from './components/PendingReviewDetail/PendingReviewDetail';


// // Attempt at auth
// import AuthService from './utils/AuthService'
//
// const auth = new AuthService('NvxhSB8nPFoX0SrNurFgM2x8jxp5XMTj', 'calebeno.auth0.com');
//
// // onEnter callback to validate authentication in private routes
// const requireAuth = (nextState, replace) => {
//     if (!auth.loggedIn()) {
//         replace({ pathname: '/login' })
//     }
// };

// auth={auth} onEnter={requireAuth}

export default (
    <Route path="/" component={App}>
        <IndexRoute component={WelcomeToBookApp}/>
        <Route path="admin" component={AdminApp}> {/*Admin Navigation*/}
            <IndexRoute component={AdminHomePage}/> {/*Admin Home*/}
            <Route path="order" component={NewOrder} />
            {/*<Route path="pending" component={PendingReviews} />*/}
            {/*<Route path="pending/:requestId" component={PendingReviewDetail} />*/}
            <Route path="history" component={OrderHistory} />
            <Route path="history/:requestId" component={OrderDetail} />
        </Route>
        <Route path="user" component={UserApp}> {/*User Navigation*/}
            <IndexRoute component={UserHomePage}/> {/*User Home*/}
            <Route path="order" component={NewOrder} />
            <Route path="history" component={OrderHistory} />
            <Route path="history/:requestId" component={OrderDetail} />
        </Route>
    </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/